const {AdminSubtitle} = require("../../../AdminLayout");
const React = require("react");

module.exports = () => (
  <div className="mt30">
    <AdminSubtitle text="Please provide us with supporting documents" />
    <p className="mv18 f12 lh18">
      We need these documents to open your account with us.<br/>
      Accepted file types: PDF, scanned copy, clear photo (JPEG, JPG, PNG), with each document not exceeding 16 MB.
    </p>
  </div>
)
